import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FaqItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FaqItem({
  question,
  answer,
  isOpen,
  onToggle
}: FaqItemProps) {
  return <div className="bg-midnight-800 border border-midnight-700/60 rounded-lg overflow-hidden" data-id="element-147">
      <button onClick={onToggle} className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-rescue-gold/50 focus-visible:ring-inset" aria-expanded={isOpen} data-id="element-148">
        <span className="font-body text-base md:text-lg font-semibold text-white" data-id="element-149">
          {question}
        </span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="flex-shrink-0" data-id="element-150">
          <ChevronDownIcon className="w-5 h-5 text-rescue-gold" aria-hidden="true" data-id="element-151" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-152">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} data-id="element-153">
            <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-154">
              <p className="font-body text-gray-400 leading-relaxed" data-id="element-155">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="px-4 py-20 md:py-28" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-158">
          <div className="border-t-2 border-rescue-gold/40 w-16 mb-6" aria-hidden="true" data-id="element-159" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-10" data-id="element-160">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: 'easeOut'
      }} className="space-y-3" data-id="element-161">
          <FaqItem question="Is this legal?" answer="Yes. It is your legal right to file directly with the IRS for free. We just show you how to find the portal they don't advertise." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-162" />
          <FaqItem question="What if I already started on TurboTax?" answer="You can leave at any time. Your data is on your W-2. We show you how to re-enter it into the free system in 12 minutes." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-163" />
          <FaqItem question="Does this include state filing?" answer="Yes, we identify the specific portals that include both Federal and State for $0." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-164" />
          <FaqItem question="I haven't filed in years. Can I use this?" answer='Yes. This is the best way to "re-enter" the system without fear.' isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-165" />
          <FaqItem question="How fast is the refund?" answer="Using the Direct File Bypass is the fastest way to get a refund (usually 21 days or less)." isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-166" />
          <FaqItem question="What if I owe money and can't pay?" answer="Chapter 4 shows you the exact buttons to click to set up a $25/month payment plan automatically." isOpen={openIndex === 5} onToggle={() => handleToggle(5)} data-id="element-167" />
        </motion.div>
      </div>
    </section>;
}